import { useEffect } from 'react';

const PopunderScript = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//pl26689578.profitableratecpm.com/d0/d0/30/d0d0306d89eacc3f42e08a179761778d.js';
    script.type = 'text/javascript';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script); // limpieza al desmontar
    };
  }, []);

  return null; // no renderiza nada
};

export default PopunderScript;
